import PropTypes from 'prop-types';
import * as styles from '../../styles/shared/footnote-link.module.scss';

const FootnoteLink = ({ footnoteId, index, href }) => {
  if (href && index) {
    return (
      <sup className={styles.footnoteSuper}>
        <span className={styles.footnoteLinkParenthesis}>(</span>
        <a className={styles.footnoteLink} href={href} id={`footnote-ref-${index}`}>
          {index}
        </a>
        <span className={styles.footnoteLinkParenthesis}>)</span>
      </sup>
    );
  }

  return (
    <span className={styles.footnotePlaceholder} data-footnote-id={footnoteId} data-footnote-placeholder="true">
      (?)
    </span>
  );
};

FootnoteLink.propTypes = {
  footnoteId: PropTypes.string,
  href: PropTypes.string,
  index: PropTypes.number,
};

export default FootnoteLink;
